'use strict';

// Shopify owns authentication. This script collects no customer data or tokens.
// Activate only after the matching native Shopify discount is saved and verified.
const WELCOME_OFFER=Object.freeze({percent:10,code:'WELCOME10',active:true,delayMs:9000});
function safeCustomerAccountUrl(value){
  try{
    const url=new URL(value,location.origin);
    if(url.protocol!=='https:'||url.username||url.password)return '';
    const local=url.origin===location.origin&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account(?:\/|$)|customer_authentication\/(?:redirect|login)(?:\/|$))/i.test(url.pathname);
    const hosted=url.hostname==='shopify.com'&&/^\/63878365339\/account(?:\/|$)/.test(url.pathname);
    return local||hosted?url.href:'';
  }catch{return '';}
}
function customerAccountState(){
  const config=document.getElementById('tjs-customer-account');
  if(config?.dataset.enabled!=='true')return {enabled:false,signedIn:false,href:''};
  const signedIn=config.dataset.signedIn==='true';
  const href=safeCustomerAccountUrl(signedIn?config.dataset.accountUrl:config.dataset.loginUrl);
  return {enabled:Boolean(href),signedIn,href};
}
function mountCustomerAccountLinks(){
  const state=customerAccountState();
  if(!state.enabled)return;
  const header=document.getElementById('header-actions');
  function update(){
    const old=header?.querySelector('button[data-action="account"]');
    if(!old)return;
    const link=document.createElement('a');
    link.className=old.className;
    link.href=state.href;
    link.rel='nofollow';
    link.setAttribute('aria-label',state.signedIn?'Your account and orders':'Sign in to your account');
    link.innerHTML=old.innerHTML;
    old.replaceWith(link);
  }
  update();
  // Bag/favorites changes rebuild the preview header. Keep the real account link.
  if(header)new MutationObserver(update).observe(header,{childList:true});
  const navigation=document.getElementById('navigation');
  if(navigation&&!navigation.querySelector('[data-customer-account-mobile]')){
    const entry=document.createElement('div');
    entry.className='nav-direct mobile-contact-entry';
    const link=document.createElement('a');
    link.dataset.customerAccountMobile='';
    link.href=state.href;
    link.rel='nofollow';
    link.textContent=state.signedIn?'Your account & orders':'Sign in / create account';
    entry.append(link);
    navigation.append(entry);
  }
}
mountCustomerAccountLinks();

const WELCOME_SESSION='tjs-welcome10-v1';
function welcomeRead(key){try{return sessionStorage.getItem(WELCOME_SESSION+':'+key)||'';}catch{return '';}}
function welcomeWrite(key,value){try{sessionStorage.setItem(WELCOME_SESSION+':'+key,String(value));}catch{}}
function welcomeRemove(key){try{sessionStorage.removeItem(WELCOME_SESSION+':'+key);}catch{}}
function welcomeCustomer(){
  const state=document.getElementById('tjs-welcome-customer')?.dataset||{};
  return {eligible:state.eligible==='true',returning:state.returning==='true'};
}
function welcomeSafeReturn(value){
  try{
    const url=new URL(value,location.origin);
    if(url.origin!==location.origin||url.username||url.password||url.protocol!=='https:')return '/';
    if(!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:pages|products|collections|blogs)\/[^?#]*|cart\/?|checkout\/?)?$/i.test(url.pathname))return '/';
    // Submission-state query strings never become a second success signal.
    return url.pathname+url.hash;
  }catch{return '/';}
}
function welcomeDiscountUrl(value){
  const returnPath=welcomeSafeReturn(value);
  const root=String(window.Shopify?.routes?.root||'/');
  const safeRoot=/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root)?root:'/';
  return safeRoot+'discount/'+WELCOME_OFFER.code+'?redirect='+encodeURIComponent(returnPath);
}
function welcomeSignupReady(){
  if(welcomeCustomer().returning)return false;
  const timestamp=Number(welcomeRead('signup-received'));
  const age=Date.now()-timestamp;
  return welcomeCustomer().eligible||(timestamp>0&&age>=0&&age<86400000);
}
window.TJSWelcomeOffer=Object.freeze({
  checkoutUrl(value){
    if(!WELCOME_OFFER.active||!welcomeSignupReady())return value;
    try{
      const url=new URL(value,location.origin);
      if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/i.test(url.pathname))return value;
      return welcomeDiscountUrl(url.href);
    }catch{return value;}
  }
});
function welcomeTemplateMarker(selector){
  return document.querySelector(selector)||document.getElementById('tjs-welcome-signup-template')?.content?.querySelector(selector);
}
function welcomePending(){
  try{
    const pending=JSON.parse(welcomeRead('pending')||'null');
    const age=pending?Date.now()-Number(pending.at):-1;
    return pending&&Number(pending.at)>0&&age>=0&&age<1800000?pending:null;
  }catch{return null;}
}
function completeWelcomeSignup(){
  const pending=welcomePending();
  // Both the native server-rendered success and this tab's valid form submission
  // are required. A URL parameter, modal click or dismissal never earns this state.
  if(!WELCOME_OFFER.active||!pending||!welcomeTemplateMarker('[data-tjs-welcome-success]'))return false;
  welcomeRemove('pending'); // Consume before navigating: refresh cannot loop.
  welcomeWrite('signup-received',Date.now());
  welcomeWrite('signup-notice',Date.now());
  welcomeWrite('shown','1');
  // Keep the native success response visible. Checkout applies WELCOME10 through
  // checkoutUrl(), so signup does not need another discount/return page load.
  return true;
}
function welcomeOfferMarkup(){
  const state=customerAccountState(),customer=welcomeCustomer();
  const form=document.getElementById('tjs-welcome-signup-template')?.innerHTML||'';
  let content;
  if(!WELCOME_OFFER.active)content='<p class="welcome-pending-copy">Our 10% welcome offer is being prepared. Please check back soon.</p>';
  else if(customer.returning)content='<p class="welcome-pending-copy">WELCOME10 is for subscribers placing their first order. Explore the latest pieces or visit your account.</p>';
  else if(welcomeSignupReady())content='<p class="welcome-pending-copy" role="status">Your welcome offer is ready to be checked at checkout. If we sent a confirmation email, confirm your subscription first. Use the same email at checkout.</p><p class="welcome-offer-code">WELCOME10</p>';
  else content=form||'<p class="welcome-pending-copy">Please use the newsletter form at the bottom of this page to join us.</p>';
  const account=state.enabled?'<a class="welcome-account-link" data-welcome-account href="'+esc(state.href)+'" rel="nofollow">'+(state.signedIn?'Your account &amp; orders':'Already have an account? Sign in')+'</a>':'';
  return localMarkup('<button type="button" class="welcome-close" data-welcome-close aria-label="Close welcome offer" autofocus>×</button><div class="welcome-layout"><div class="welcome-image"><img src="https://cdn.shopify.com/s/files/1/0638/7836/5339/files/tjs-welcome-ribbon-20261009.jpg?v=1791484935&amp;width=900" alt="Diamond ring on a twisted satin ribbon against a burgundy background" width="1584" height="2816"><span class="welcome-image-caption" aria-hidden="true">THE JEWELRY STUDIO</span></div><div class="welcome-copy"><p class="eyebrow">WELCOME TO THE STUDIO</p><h2 id="welcome-title" class="welcome-headline"><span class="welcome-value">10%</span> <em>off</em></h2><p id="welcome-description" class="welcome-intro">Your first order, with a little extra.</p>'+content+'<p class="welcome-terms">For email subscribers on their first order. One use per customer. Cannot be combined with other discounts. Shopify confirms eligibility at checkout.</p>'+account+'<button type="button" class="welcome-decline" data-welcome-close>Maybe later</button></div></div>');
}
const welcomeDialog=document.createElement('dialog');
welcomeDialog.id='welcome-offer';
welcomeDialog.className='welcome-dialog';
welcomeDialog.setAttribute('aria-labelledby','welcome-title');
welcomeDialog.setAttribute('aria-describedby','welcome-description');
document.body.append(welcomeDialog);
let welcomeOpenedThisSession=welcomeRead('shown')==='1';
let welcomeLastFocus=null;
function welcomeBusy(){
  return welcomeDialog.open||Boolean(document.querySelector('dialog[open]'))||document.hidden||Boolean(document.activeElement?.matches('input,textarea,select,[contenteditable="true"]'));
}
function welcomeIsHome(){
  return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(location.pathname||'/')&&['','#','#/'].includes(location.hash||'');
}
function openWelcomeOffer(manual=false){
  if(welcomeDialog.open||document.querySelector('dialog[open]'))return false;
  if(!manual&&(!WELCOME_OFFER.active||welcomeOpenedThisSession||!welcomeIsHome()||welcomeCustomer().returning||welcomeSignupReady()||welcomeBusy()))return false;
  welcomeLastFocus=document.activeElement;
  welcomeDialog.innerHTML=welcomeOfferMarkup();
  welcomeDialog.showModal();
  welcomeOpenedThisSession=true;
  welcomeWrite('shown','1');
  return true;
}
function welcomeHasSignupNotice(){
  const timestamp=Number(welcomeRead('signup-notice')),age=Date.now()-timestamp;
  return timestamp>0&&age>=0&&age<1800000;
}
function showWelcomeSignupNotice(){
  if(!WELCOME_OFFER.active||!welcomeHasSignupNotice()||welcomeBusy())return false;
  welcomeLastFocus=document.activeElement;
  welcomeDialog.innerHTML=localMarkup('<button type="button" class="welcome-close" data-welcome-close aria-label="Close signup confirmation" autofocus>×</button><div class="welcome-layout"><div class="welcome-image"><img src="https://cdn.shopify.com/s/files/1/0638/7836/5339/files/tjs-welcome-ribbon-20261009.jpg?v=1791484935&amp;width=900" alt="Diamond ring on a twisted satin ribbon against a burgundy background" width="1584" height="2816"><span class="welcome-image-caption" aria-hidden="true">THE JEWELRY STUDIO</span></div><div class="welcome-copy"><p class="eyebrow">WELCOME TO THE STUDIO</p><h2 id="welcome-title" class="welcome-pending-title">Thank you<br>for joining us.</h2><p id="welcome-description" class="welcome-pending-copy" role="status">Your signup was received. If we sent a confirmation email, confirm your subscription first. Use the same email at checkout.</p><p class="welcome-offer-code">WELCOME10</p><p class="welcome-terms">Shopify checks your eligibility for 10% off your first order at checkout. One use per customer. Cannot be combined with other discounts.</p><button type="button" class="button full" data-welcome-close>Continue exploring <span aria-hidden="true">↗</span></button></div></div>');
  welcomeDialog.showModal();
  welcomeRemove('signup-notice'); // Consume only after the notice is visible.
  welcomeOpenedThisSession=true;
  welcomeWrite('shown','1');
  return true;
}
let welcomeNoticeTimer=null;
function scheduleWelcomeNotice(delay=100){
  if(welcomeNoticeTimer!==null||!WELCOME_OFFER.active||!welcomeHasSignupNotice())return;
  welcomeNoticeTimer=setTimeout(()=>{
    welcomeNoticeTimer=null;
    if(!showWelcomeSignupNotice()&&!document.hidden&&welcomeHasSignupNotice())scheduleWelcomeNotice(2000);
  },delay);
}
welcomeDialog.addEventListener('close',()=>{
  welcomeWrite('shown','1');
  if(welcomeLastFocus?.isConnected)welcomeLastFocus.focus({preventScroll:true});
});
welcomeDialog.addEventListener('click',event=>{
  if(event.target.closest('[data-welcome-close],[data-welcome-account]'))welcomeDialog.close();
  if(event.target===welcomeDialog){const r=welcomeDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)welcomeDialog.close();}
});
document.addEventListener('click',event=>{if(event.target.closest('[data-action="welcome-offer"]'))openWelcomeOffer(true);});
document.addEventListener('submit',event=>{
  const form=event.target;
  if(!WELCOME_OFFER.active||!['TJSWelcomeSignup','TJSStudioLetter'].includes(form?.id)||!form.checkValidity())return;
  welcomeWrite('pending',JSON.stringify({at:Date.now(),returnTo:welcomeSafeReturn(location.href),formId:form.id}));
  // Native Shopify submission handles validation, CAPTCHA and subscription.
});
let welcomeTimer=null,welcomeDue=false;
function scheduleWelcomeRetry(delay=500){
  if(welcomeTimer!==null||!WELCOME_OFFER.active||welcomeOpenedThisSession)return;
  welcomeTimer=setTimeout(()=>{
    welcomeTimer=null;
    if(!welcomeDue||welcomeOpenedThisSession)return;
    if(!openWelcomeOffer()&&!document.hidden&&welcomeIsHome()&&!welcomeSignupReady()&&!welcomeCustomer().returning)scheduleWelcomeRetry(2000);
  },delay);
}
const welcomeCompleted=completeWelcomeSignup();
// Confirm on the native response, including repeat subscriptions. No extra
// navigation should delay feedback or discard the server-rendered confirmation.
scheduleWelcomeNotice();
if(WELCOME_OFFER.active&&!welcomeCompleted){
  const pending=welcomePending();
  if(pending?.formId==='TJSWelcomeSignup'&&welcomeTemplateMarker('[data-tjs-welcome-error]')){
    welcomeRemove('pending');
    openWelcomeOffer(true);
  }else if(!welcomeOpenedThisSession){
    welcomeTimer=setTimeout(()=>{welcomeTimer=null;welcomeDue=true;scheduleWelcomeRetry(0);},WELCOME_OFFER.delayMs);
  }
}
document.addEventListener('visibilitychange',()=>{if(!document.hidden){scheduleWelcomeNotice();if(welcomeDue)scheduleWelcomeRetry();}});
document.addEventListener('focusout',()=>{scheduleWelcomeNotice();if(welcomeDue)scheduleWelcomeRetry();});
document.addEventListener('close',()=>{scheduleWelcomeNotice();if(welcomeDue)scheduleWelcomeRetry();},true);
window.addEventListener('hashchange',()=>{if(welcomeDue)scheduleWelcomeRetry();});

